// src/hooks/useClientStorage.mjs
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { clearClientData, hasClientData } from '../utils/clientStorage.mjs';

export const useClientStorage = () => {
    const location = useLocation();

    useEffect(() => {
        // Se está na raiz, limpa os dados do cliente
        if (location.pathname === '/') {
            clearClientData();
        }
    }, [location.pathname]);

    return {
        hasClientData: hasClientData()
    };
};
